import Vue from 'vue'
import axios from 'axios'
const CancelToken = axios.CancelToken
const source = CancelToken.source();
let pendingAjax = []

async function useApi(config, request, params) {
  console.log(request)
  return new Promise((resolve, reject) => {

    let cancel
    if (config.noRepeat) {
      pendingAjax.push(request)
    }
    request(params, {
      headers: { a: 1 },
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      })
    }).then(res => {
      // resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
  cancel('Operation canceled by the user.');
}

useApi.install = function (Vue, options) {
  Vue.useApi = useApi
  window.useApi = useApi
  Object.defineProperties(Vue.prototype, {
    useApi: {
      get() {
        return useApi
      }
    }
  })
}

Vue.use(useApi)

export default useApi